import React from "react";

const MassageCard = (props) => {
  const { title, description, style } = props;
  return (
    <div className='bg-[#FFFBE6] rounded-2xl w-[248px] h-[272px] px-4' style={{...style}}>
        <p className='font-font-Titillium text-[#141414] text-xl leading-[26px] font-semibold tracking-[.00625em] uppercase pt-4 sm:pt-8 w-[80%] h-[48px]'>
            {title}
        </p>
        <p className='font-font-Titillium text-[#262626] text-lg leading-[24px] font-normal tracking-[.0313em] pt-4 sm:pt-8 mt-3'>
            {description}
        </p>
    </div>
  );
};

export default MassageCard;
